import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import BookingForm from '../BookingForm';
import SEO from '../SEO.js';
import './ServicePages.css';

const ICUAtHome = () => {
  const [showBookingForm, setShowBookingForm] = useState(false);

  const handleBookNow = () => {
    setShowBookingForm(true);
  };

  const handleCloseBooking = () => {
    setShowBookingForm(false);
    // Fix button color after form closes
    const buttons = document.querySelectorAll('.book-now-hero-btn, .cta-button, .sidebar-book-btn');
    buttons.forEach(button => {
      if (button.classList.contains('book-now-hero-btn') || button.classList.contains('sidebar-book-btn') || button.classList.contains('cta-button')) {
        button.style.backgroundColor = 'var(--primary-color)';
        button.style.border = 'none';
        button.style.color = 'var(--white-color)';
      }
    });
  };

  const benefits = [
    'Hospital-level care in familiar surroundings',
    'Reduced risk of hospital-acquired infections',
    'One-on-one attention from dedicated medical staff',
    'Greater comfort and privacy for patients',
    'Family involvement in care',
    'Potentially faster recovery in comfortable environment'
  ];

  const icuServices = [
    {
      name: 'Critical Care Monitoring',
      description: 'Continuous monitoring of vital signs and health parameters by trained medical professionals.'
    },
    {
      name: 'Respiratory Support',
      description: 'Management of ventilators, oxygen therapy, and other respiratory interventions as needed.'
    },
    {
      name: 'Post-Surgical ICU Care',
      description: 'Specialized care for patients recovering from major surgeries requiring intensive monitoring.'
    },
    {
      name: 'Chronic Critical Illness Management',
      description: 'Long-term intensive care for patients with complex, chronic conditions requiring continuous support.'
    }
  ];

  return (
    <div className="service-page icu-page">
      <SEO 
        title="ICU at Home Services in Bangalore"
        description="Hospital-grade ICU at home services in Bangalore. Critical care monitoring, respiratory support, and 24/7 nursing care for patients recovering at home."
        keywords="ICU at home Bangalore, critical care at home, home ventilator support, ICU setup at home, critical care nursing"
      />
      <div className="service-hero">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} md={12}>
              <div className="service-hero-content">
                <h1>ICU At Home Services</h1>
                <p>Hospital-grade critical care in the comfort of your home</p>
                <Button className="book-now-hero-btn" onClick={handleBookNow}>
                  Book Consultation
                </Button>
              </div>
            </Col>
            <Col lg={6} md={12}>
              <div className="service-hero-image">
                <img src="/images/icu.jpg" alt="ICU At Home Services" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="service-content">
        <Row>
          <Col lg={8} md={12}>
            <div className="service-description">
              <h2>Professional ICU Care at Home</h2>
              <p>
                Our ICU At Home service brings hospital-grade critical care to the comfort and privacy of your home. 
                This service is designed for patients who require intensive monitoring and treatment but prefer to 
                receive care in a familiar environment rather than a hospital setting.
              </p>
              <p>
                Our team of critical care specialists, including intensivists, critical care nurses, and respiratory 
                therapists, works together to provide comprehensive care using advanced medical equipment and 
                monitoring systems. We maintain the same standards of care as a hospital ICU while offering the 
                comfort, privacy, and personalized attention that comes with home-based care.
              </p>
              
              <h3>Our ICU At Home Services</h3>
              <Row className="treatment-cards">
                {icuServices.map((service, index) => (
                  <Col md={6} key={index} className="mb-4">
                    <Card className="treatment-card h-100">
                      <Card.Body>
                        <Card.Title>{service.name}</Card.Title>
                        <Card.Text>{service.description}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
              
              <h3 className="mt-4">What Our ICU At Home Includes</h3>
              
            </div>
            <ul className="service-list">
                <li>24/7 monitoring by critical care professionals</li>
                <li>Advanced life support equipment</li>
                <li>Ventilator management</li>
                <li>Continuous cardiac monitoring</li>
                <li>IV medication administration</li>
                <li>Regular physician visits and telemedicine support</li>
                <li>Laboratory and diagnostic services</li>
                <li>Coordination with specialists and primary care providers</li>
              </ul>
          </Col>
          
          <Col lg={4} md={12}>
            <div className="service-sidebar">
              <Card className="benefits-card">
                <Card.Header as="h5">Benefits of ICU At Home</Card.Header>
                <Card.Body>
                  <ul className="benefits-list">
                    {benefits.map((benefit, index) => (
                      <li key={index}>{benefit}</li>
                    ))}
                  </ul>
                  <div className="d-grid gap-2 mt-4">
                    <Button variant="primary" onClick={handleBookNow} className="sidebar-book-btn">
                      Request ICU Consultation
                    </Button>
                  </div>
                </Card.Body>
              </Card>
              
              <Card className="why-choose-card mt-4">
                <Card.Header as="h5">Why Choose Our ICU At Home?</Card.Header>
                <Card.Body>
                  <ul className="why-choose-list">
                    <li>Experienced critical care medical team</li>
                    <li>Hospital-grade equipment and monitoring</li>
                    <li>Personalized care plans</li>
                    <li>Seamless coordination with hospitals if needed</li>
                    <li>Comprehensive family support and education</li>
                  </ul>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={12}>
            <div className="cta-section text-center">
              <h3>Need Critical Care at Home?</h3>
              <p>Our specialized ICU team is ready to provide hospital-level care in the comfort of your home.</p>
              <Button size="lg" onClick={handleBookNow} className="cta-button">
                Schedule an ICU Consultation
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
      
      <BookingForm 
        show={showBookingForm} 
        handleClose={handleCloseBooking} 
        defaultService="ICU At Home"
      />
    </div>
  );
};

export default ICUAtHome;
